import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AccountState } from '@account-users/account/models/IAccount';
import { BootstrapStatus } from '@account-users/account/models/BootstrapStatus';

@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html',
  styleUrls: ['./account-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatusComponent {
  @Input() accountStatus: BootstrapStatus;
  @Input() isBootstrapComplete = false;

  AccountState = AccountState;
}
